import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useToggle from '../../hooks/useToggle';
import { openSnackbar } from '../../features/SnackBar/snackBarSlice';
import { getFeaturesList, saveSiteConfiguration } from '../../features';
import { resetAccountsList } from '../../features/AccountList/accountListSlice';

function useActiveUserConfig() {
  const dispatch = useDispatch();
  const [config, setConfig] = useToggle();
  const [selectedKpi, setSelectedKpi] = useState('');
  const [enableSave, setEnableSave] = useToggle();

  const featuresList = useSelector((state) => state.featureManagerList.featureManagerList);
  const siteConfiguration = useSelector((state) => state.siteConfiguration?.data);

  useEffect(() => {
    dispatch(getFeaturesList());
  }, []);

  useEffect(() => {
    if (siteConfiguration) {
      setConfig(siteConfiguration?.activeUserEnabled ?? false);
      setSelectedKpi(siteConfiguration?.activeUserFeatureId ?? '');
    }
  }, [siteConfiguration]);

  const handleSave = () => {
    if (config && !selectedKpi) {
      dispatch(openSnackbar({ open: true, message: 'Please select a Feature or disable active user configuration.', type: 'error' }));
      return;
    }

    if (!config) setSelectedKpi('');

    const data = {
      activeUserEnabled: config,
      activeUserFeatureId: config ? selectedKpi : null,
    };

    dispatch(saveSiteConfiguration(data)).then((res) => {
      if (res?.payload?.status === 'SUCCESS') {
        dispatch(resetAccountsList());
        dispatch(openSnackbar({ open: true, message: 'Active user configuration saved successfully.', type: 'success' }));
      }
      if (res?.error) {
        dispatch(openSnackbar({ open: true, message: 'Failed to save active user configuration.', type: 'error' }));
      }
      return null;
    });

    setEnableSave(false);
  };

  const handleEnableConfig = (e) => {
    setConfig(e.target.value);
    setEnableSave(true);
  };

  const handleFeatureChange = (e) => {
    setSelectedKpi(e.target.value);
    setEnableSave(true);
  };

  const filteredFeatures = useMemo(() => {
    return featuresList?.map((item) => ({
      id: item.feature_id,
      name: item.feature_name,
      value: item.feature_id,
    }));
  }, [featuresList]);

  return {
    filteredFeatures,
    siteConfiguration,
    enableSave,
    config,
    selectedKpi,
    handleSave,
    handleEnableConfig,
    handleFeatureChange,
  };
}

export default useActiveUserConfig;
